import { z } from 'zod'

export const couponEventSchema = z.object({
  date: z.string(), // ISO 8601 (YYYY-MM-DD) — the coupon day, all the screener needs
  amount: z.number(), // ₽ paid per one bond
  // full-fidelity fields the payments sync needs on top of the screener's date+amount. optional
  // because a schedule persisted before they existed parses as a valid v1 payload; a caller that
  // needs them passes `requireDetails` to CouponCacheService and gets a refetch rather than a
  // lossy row. couponDate carries the broker's exact timestamp so a cached schedule reproduces
  // the same paymentDate the direct API path stored.
  couponDate: z.string().optional(), // ISO 8601 timestamp
  fixDate: z.string().nullable().optional(), // record date
  currency: z.string().nullable().optional(),
})
export type CouponEvent = z.infer<typeof couponEventSchema>

export const ofzBondSchema = z.object({
  uid: z.string(),
  figi: z.string(),
  ticker: z.string(),
  isin: z.string(),
  name: z.string(),
  nominal: z.number(), // ₽ face value (≈1000)
  maturityDate: z.string(), // ISO 8601
  couponsPerYear: z.number().int(),
  aci: z.number(), // ₽ accrued coupon income now
  cleanPricePct: z.number(), // last price as % of nominal
  coupons: z.array(couponEventSchema), // remaining (future) coupons
})
export type OfzBond = z.infer<typeof ofzBondSchema>
